import {
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import {
  selectNavigationHasSave,
  selectNavigationShouldMobileMenuBeOpen,
} from '../navigation-state/navigation-state.selectors';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Router,
} from '@angular/router';
import { AliveState } from '../../../core/ActiveState';
import { filter, first, map, startWith, switchMap } from 'rxjs/operators';
import { BehaviorSubject, combineLatest, of } from 'rxjs';
import { NavigationService } from '../navigation.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
    selector: 'lib-sub-navigation-container',
    templateUrl: './sub-navigation-container.component.html',
    styleUrls: ['./sub-navigation-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SubNavigationContainerComponent
  extends AliveState
  implements OnInit
{
  shouldOpenSubNavigation$ = this.store.pipe(
    select(selectNavigationShouldMobileMenuBeOpen)
  );
  @Input() willHaveTitle = false;
  hasSave$ = this.store.pipe(select(selectNavigationHasSave));
  @Input() submenuDisabled = false;
  dataElements$ = of(false).pipe(
    switchMap(() => {
      const routers = [this.route.data];
      if (this.route.firstChild) {
        routers.push(this.route.firstChild.data);
        if (this.route.firstChild.firstChild) {
          routers.push(this.route.firstChild.firstChild.data);
          if (this.route.firstChild.firstChild.firstChild) {
            routers.push(this.route.firstChild.firstChild.firstChild.data);
          }
        }
      }

      return combineLatest(routers);
    })
  );
  navigationStart$ = this.router.events.pipe(
    filter(
      (ev) => ev instanceof NavigationStart || ev instanceof NavigationEnd
    ),
    startWith(false)
  );
  isFullContainer$ = this.navigationStart$.pipe(
    switchMap(() => {
      return this.dataElements$.pipe(
        map(
          (allData) =>
            !!allData.find(
              ({ navigationFullContainer }) => !!navigationFullContainer
            )
        ),
        startWith(false)
      );
    })
  );
  isMobile$ = this.screenObserver
    .observe(Breakpoints.Handset)
    .pipe(map(({ matches }) => matches));
  isNoPadding$ = this.navigationStart$.pipe(
    switchMap(() =>
      this.dataElements$.pipe(
        map(
          (allData) =>
            !!allData.find(({ navigationNoPadding }) => !!navigationNoPadding)
        ),
        startWith(false)
      )
    )
  );
  mayHaveCover$ = new BehaviorSubject(false);
  originalHeight = window.innerHeight;

  @ViewChild('saveButton', { static: false })
  set saveButtonNode(node: ElementRef<HTMLElement>) {
    if (node) {
      this.navigationService.saveButton = node.nativeElement;
    }
  }

  @HostBinding('class.moveUp') get height() {
    let value = true;
    this.screenObserver
      .observe([Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape])
      .pipe(
        first(),
        map(({ matches }) => matches)
      )
      .subscribe((matches) => (value = matches));
    return value && this.originalHeight > window.innerHeight;
  }

  constructor(
    private el: ElementRef,
    private screenObserver: BreakpointObserver,
    private store: Store,
    private router: Router,
    public navigationService: NavigationService,
    public route: ActivatedRoute
  ) {
    super();
  }

  ngAfterViewChecked() {}

  ngOnInit(): void {
    this.subscribeWhileAlive();
  }
}
